import { useState } from 'react';

const directions = [
  {
    icon: 'ri-car-line',
    title: 'Mit dem Auto',
    lines: [
      'A4 Richtung Köln/Olpe – Ausfahrt Gummersbach',
      'B256 Richtung Wiehl – weiter Richtung Reichshof',
      'In Reichshof der Beschilderung „Wehnrath / Gewerbepark" folgen',
      'Gewerbeparkstr. 8 – Parkplätze direkt vor Ort vorhanden',
    ],
  },
  {
    icon: 'ri-train-line',
    title: 'Mit der Bahn',
    lines: [
      'Bahnhof Gummersbach (Linie S19 ab Köln)',
      'Ab Gummersbach weiter mit Bus Linie 304 Richtung Reichshof',
      'Haltestelle „Wehnrath" – ca. 5 Min. Fußweg',
    ],
  },
  {
    icon: 'ri-map-pin-2-line',
    title: 'Koordinaten',
    lines: [
      'Gewerbeparkstr. 8, 51580 Reichshof-Wehnrath',
      'GPS: 51.0167° N, 7.6500° O',
      'Google Maps: „gowiTEC Reichshof" suchen',
    ],
  },
];

const MapSection = () => {
  const [mapLoaded, setMapLoaded] = useState(false);

  return (
    <section className="w-full">
      {/* Google Maps */}
      <div className="relative w-full h-[440px] md:h-[520px] bg-gray-100 rounded-xl overflow-hidden mb-8">
        {!mapLoaded ? (
          <div className="absolute inset-0 flex flex-col items-center justify-center bg-[#F8FAFC] border-2 border-dashed border-gray-200 rounded-xl">
            <div className="text-center max-w-sm px-6">
              <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4 bg-[#1E3A8A]/10 rounded-full">
                <i className="ri-map-pin-2-line text-3xl text-[#1E3A8A]"></i>
              </div>
              <h3 className="text-gray-800 font-semibold text-lg mb-2">Google Maps anzeigen</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">
                Durch das Laden der Karte werden Daten an Google übertragen.
                Bitte stimmen Sie zu, um die Karte anzuzeigen.
              </p>
              <p className="text-gray-400 text-xs mb-5">
                Weitere Informationen in unserer{' '}
                <a href="/datenschutz" className="text-[#1E3A8A] underline cursor-pointer">
                  Datenschutzerklärung
                </a>.
              </p>
              <button
                onClick={() => setMapLoaded(true)}
                className="bg-[#1E3A8A] text-white text-sm font-semibold px-6 py-3 rounded-md hover:bg-[#1e40af] transition-colors duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2 mx-auto"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-map-2-line"></i>
                </span>
                Karte laden &amp; zustimmen
              </button>
            </div>
          </div>
        ) : (
          <iframe
            title="gowiTEC Standort – Gewerbeparkstr. 8, 51580 Reichshof-Wehnrath"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2499.123456789!2d7.649!3d51.017!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47bf3c5e5e5e5e5f%3A0xabcdef1234567890!2sGewerbeparkstr.%208%2C%2051580%20Reichshof!5e0!3m2!1sde!2sde!4v1700000000000!5m2!1sde!2sde"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full h-full"
          />
        )}
      </div>

      {/* Anfahrtsbeschreibung */}
      <div className="mb-3">
        <div className="flex items-center gap-3 mb-6">
          <span className="w-8 h-8 flex items-center justify-center bg-[#1E3A8A]/10 rounded-lg">
            <i className="ri-road-map-line text-[#1E3A8A] text-lg"></i>
          </span>
          <h2 className="text-xl font-bold text-gray-900">Anfahrtsbeschreibung</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {directions.map((dir) => (
            <div
              key={dir.title}
              className="bg-[#F8FAFC] border border-gray-100 rounded-xl p-6 hover:border-[#1E3A8A]/20 transition-colors duration-200"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center bg-[#EFF6FF] rounded-lg shrink-0">
                  <i className={`${dir.icon} text-[#1E3A8A] text-lg`}></i>
                </div>
                <h3 className="text-gray-900 font-semibold text-base">{dir.title}</h3>
              </div>
              <ul className="flex flex-col gap-2.5">
                {dir.lines.map((line, i) => (
                  <li key={i} className="flex items-start gap-2.5 text-gray-600 text-sm leading-relaxed">
                    <span className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                      <i className="ri-arrow-right-s-line text-[#1E3A8A]"></i>
                    </span>
                    {line}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Google Maps Link */}
        <div className="mt-5 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <a
            href="https://www.google.com/maps/dir/?api=1&destination=Gewerbeparkstr.+8,+51580+Reichshof"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#1E3A8A] hover:bg-[#1e40af] text-white text-sm font-semibold px-5 py-2.5 rounded-md transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-navigation-line"></i>
            </span>
            Route in Google Maps starten
          </a>
          <p className="text-xs text-gray-400 flex items-center gap-1.5">
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-shield-check-line"></i>
            </span>
            Die Karte wird erst nach Ihrer Zustimmung geladen (DSGVO-konform).
            Es werden dann Daten an Google LLC übertragen.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
